import { Validators } from '@angular/forms';
import { ControlProperty } from '../../../../../common/models';
import { LocalDateRangeModel, LocalDateRangeOutputModel } from '../../../../models';
import { AllocationDetailsModel } from './allocation-details';
import { createDateWithTimezoneOffset } from '../../../../../common';

export class AllocationViewTimeslot {
  dockId: number;
  dockName: string;
  durationInMins: number;
  end: number;
  start: number;

  constructor(params?: AllocationViewTimeslot) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class AllocationViewTimeslotInputModel {
  dockId: number;
  dockName: string;
  durationInMins: number;
  end: number;
  start: number;
  minServiceTime: number;
  maxServiceTime: number;

  constructor(params?: AllocationViewTimeslotOutputModel) {
    if (params) {
      const { timeSlot, ...rest } = params;
      Object.assign(this, rest);

      this.start = createDateWithTimezoneOffset(timeSlot.start.timestamp, timeSlot.start.timezone).getTime();
      this.end = createDateWithTimezoneOffset(timeSlot.end.timestamp, timeSlot.end.timezone).getTime();
    }
  }
}

export class AllocationViewTimeslotOutputModel {
  dockId: number;
  dockName: string;
  durationInMins: number;
  timeSlot: LocalDateRangeModel;

  constructor(params?: AllocationViewTimeslot, timezone?: string) {
    if (params) {
      const { start, end, ...rest } = params;

      Object.assign(this, rest);

      this.timeSlot = new LocalDateRangeOutputModel({ start: new Date(start), end: new Date(end) }, timezone);
    }
  }
}

export class AllocationViewTimeslotForm {
  constructor(
    model: AllocationViewTimeslot,
    public dockId: ControlProperty<number> = [model.dockId, [Validators.required]],
    public dockName: ControlProperty<string> = model.dockName,
    public start: ControlProperty<number | Date> = [
      { disabled: !model.dockId, value: model.start },
      [Validators.required],
    ],
    public end: ControlProperty<number | Date> = [{ disabled: !model.dockId, value: model.end }, [Validators.required]],
    public durationInMins: ControlProperty<number> = [
      {
        disabled: true,
        value: model.durationInMins,
      },
      [Validators.required],
    ],
  ) {}
}

export class AllocationViewTimeslotRequestModel {
  compartmentId: number;
  dockId: number;
  details: AllocationDetailsModel;

  constructor(params?: AllocationViewTimeslotRequestModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}
